<ng-template [ngIf]="keepWidthOnLoading && !icon" [ngIfElse]="stretch">
    <div class="position-relative">
        <div [ngClass]="{invisible: loading}">
            <ng-template [ngTemplateOutlet]="contentWithIcon"></ng-template>
        </div>
        <div
            *ngIf="loading"
            class="position-absolute top-0 start-0 bottom-0 end-0 d-flex align-items-center justify-content-center"
        >
            <mat-spinner
                    [color]="spinnerColor"
                    [ngClass]="{'me-2': loadingCaption}"
                    [diameter]="diameter[size]"
            ></mat-spinner>
            {{loadingCaption}}
        </div>
    </div>
</ng-template>
<ng-template #stretch>
    <ng-template [ngIf]="loading" [ngIfElse]="contentWithIcon">
        <mat-spinner
                [color]="spinnerColor"
                [ngClass]="{'me-2': loadingCaption}"
                [diameter]="diameter[size]"
        ></mat-spinner>
        {{loadingCaption}}
    </ng-template>
</ng-template>

<ng-template #contentWithIcon>
    <i *ngIf="icon" class="fa fa-{{icon}}"></i>
    <ng-content></ng-content>
</ng-template>
